
import { Checkbox, Autocomplete, Backdrop, CircularProgress, BottomNavigation, BottomNavigationAction, Box, Snackbar, Button, Card, Typography, TextField, Grid, FormControlLabel, Switch, Select, FormControl, InputLabel, MenuItem, CardHeader, CardContent, Paper, InputAdornment, useMediaQuery, useTheme, Avatar, Badge, Radio, RadioGroup } from '@mui/material';
import { useState, Fragment, useEffect, useRef } from 'react';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import DeleteIcon from '@mui/icons-material/Delete';

import OficialesFind from './OficialesFind';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import axios, { getServerBaseURL } from "../api/axios"

import SaveAltIcon from '@mui/icons-material/SaveAlt';
import AddCardIcon from '@mui/icons-material/AddCard';
import SearchIcon from '@mui/icons-material/Search';
import LockResetIcon from '@mui/icons-material/LockReset';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import AutoModeIcon from '@mui/icons-material/AutoMode';

import InversionistaFind from './InversionistaFind';

export default function MiCuenta(props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [id, setId] = useState(0);
    const [nombre, setNombre] = useState("")
    const [apellido, setApellido] = useState("")
    const [celular, setCelular] = useState("")
    const [email, setEmail] = useState("")
    const [direccion, setDireccion] = useState("")
    
    const [usuario, setUsuario] = useState("")
    const [clave, setClave] = useState("")
    const [repite, setRepite] = useState("")
    const [showClave, setShowClave] = useState(false)
    const [showRepite, setShowRepite] = useState(false)
    const [mostrarCambioPassword, setMostrarCambioPassword] = useState(false)
    const [claveOriginal, setClaveOriginal] = useState("")

    const [mensaje, setMensaje] = useState("")
    const [procesando, setProcesando] = useState(false)
    const [foto, setFoto] = useState(null)
    const [fotoPreview, setFotoPreview] = useState(null)
    const [fotoEliminada, setFotoEliminada] = useState(false)
    const fileInputRef = useRef(null)

    // Estados para inversión automática
    const [inversionAutomatica, setInversionAutomatica] = useState(0)
    const [inversionTipo, setInversionTipo] = useState("")
    const [inversionMonto, setInversionMonto] = useState("")
    const [inversionPorciento, setInversionPorciento] = useState("")

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    useEffect(() => {
        let cual = props.cual;
        inicio(cual)
        
    }, [])




    const handleClick = () => {
        if (puedeGrabar()) {
            grabar();
        }
    }

    const grabar = async () => {
        setProcesando(true)

        try {
            const respuesta = await axios.post("inversionista/profilegrabar", {
                cual: id,
                nombre: nombre,
                apellido: apellido,
                celular: celular,
                email: email,
                direccion: direccion,
                ciudad: 0,
                // Solo enviar la nueva clave si se está cambiando, sino enviar la original
                clave: mostrarCambioPassword ? clave : claveOriginal,
                // Enviar foto como base64 si existe una nueva, o "ELIMINAR" si se eliminó
                foto: foto ? fotoPreview : (fotoEliminada ? "ELIMINAR" : null),
                // Configuración de inversión automática
                inversion_automatica: inversionAutomatica,
                inversion_tipo: inversionTipo,
                inversion_monto: parseFloat(inversionMonto) || 0,
                inversion_porciento: parseFloat(inversionPorciento) || 0
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            let data = respuesta.data;
            if (data.respuesta == "S") {
                if (mostrarCambioPassword) {
                    setMensaje("Datos y contraseña actualizados exitosamente");
                    setClaveOriginal(clave);
                    setMostrarCambioPassword(false);
                } else {
                    setMensaje("Datos grabados exitosamente");
                }
                // Recargar datos para obtener la foto_url actualizada del servidor
                await inicio(id, true)
            } else {
                setMensaje(data.mensaje)
            }

        } catch (error) {
            setMensaje(error.message)
        }
        setProcesando(false)
    }

    const puedeGrabar = () => {

        let resultado = true;
        if (id==0){setMensaje("Ha ocurrido un error de conexión, por favor intente más tarde"); return false;}
        if (nombre.length == 0) { setMensaje("Debe digitar el Nombre"); return false; }

        // Solo validar contraseña si se está cambiando
        if (mostrarCambioPassword) {
            if (clave.length == 0) {
                setMensaje("Debe digitar la nueva clave");
                return false;
            }
            if (clave.length < 4) {
                setMensaje("La clave debe tener al menos 4 caracteres");
                return false;
            }
            if (repite.length == 0) {
                setMensaje("Debe confirmar la nueva clave");
                return false;
            }
            if (clave !== repite) {
                setMensaje("Las claves no coinciden");
                return false;
            }
        }

        return resultado;
    }

    const handleCancelarCambioPassword = () => {
        setMostrarCambioPassword(false);
        setClave(claveOriginal);
        setRepite(claveOriginal);
        setShowClave(false);
        setShowRepite(false);
    }
    const handleCloseMensaje = () => {
        setMensaje("")
    }
    const actionMsg = (
        <Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseMensaje}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </Fragment>
    );

    const handleFotoClick = () => {
        fileInputRef.current?.click()
    }

    const handleFotoChange = (event) => {
        const file = event.target.files[0]
        if (file) {
            if (file.size > 5 * 1024 * 1024) {
                setMensaje("La imagen no debe superar los 5MB")
                return
            }
            if (!file.type.startsWith('image/')) {
                setMensaje("Solo se permiten archivos de imagen")
                return
            }
            setFoto(file)
            setFotoEliminada(false)
            const reader = new FileReader()
            reader.onloadend = () => {
                setFotoPreview(reader.result)
            }
            reader.readAsDataURL(file)
        }
    }

    const handleEliminarFoto = () => {
        setFoto(null)
        setFotoPreview(null)
        setFotoEliminada(true)
        if (fileInputRef.current) {
            fileInputRef.current.value = ''
        }
    }

    const blanquea = () => {
        setId(0)
        setNombre("")
        setApellido("")
        setCelular("")
        setEmail("")
        setDireccion("")
        setUsuario("")
        setClave("")
        setRepite("")
        setFoto(null)
        setFotoPreview(null)
        setFotoEliminada(false)
        if (fileInputRef.current) {
            fileInputRef.current.value = ''
        }
        // Limpiar estados de inversión automática
        setInversionAutomatica(0)
        setInversionTipo("")
        setInversionMonto("")
        setInversionPorciento("")
    }

    const inicio = async (cual, esRecarga = false) => {
        // Solo limpiar campos si NO es una recarga después de guardar
        if (!esRecarga) {
            blanquea();
        }
        if (cual == 0) { return }

        setProcesando(true)
        try {
            const respuesta = await axios.post("inversionista/profileinicio", {
                cual: cual
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            const data = respuesta.data;

            setId(cual)
            setNombre(data.nombre)
            setApellido(data.apellido)
            setCelular(data.celular)
            setEmail(data.email)
            setDireccion(data.direccion)

            setUsuario(data.usuario)
            setClave(data.clave)
            setRepite(data.clave)
            setClaveOriginal(data.clave)
            setMostrarCambioPassword(false)

            // Cargar foto si existe (construir URL completa)
            if (data.foto_url) {
                setFotoPreview(`${getServerBaseURL()}${data.foto_url}`)
            } else {
                // Solo limpiar foto si no hay foto en el servidor
                setFotoPreview(null)
            }
            // Limpiar estados de foto nueva
            setFoto(null)
            setFotoEliminada(false)

            // Cargar configuración de inversión automática
            setInversionAutomatica(data.inversion_automatica || 0)
            setInversionTipo(data.inversion_tipo || "")
            // Formatear monto sin decimales innecesarios (200.0000 -> 200)
            setInversionMonto(data.inversion_monto ? parseFloat(data.inversion_monto).toString() : "")
            setInversionPorciento(data.inversion_porciento ? parseFloat(data.inversion_porciento).toString() : "")

        } catch (error) {

        }
        setProcesando(false)
    }

    const objWait = () => {
        return (
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={procesando}
                onClick={() => { setProcesando(false) }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        )
    }

    
    return (
        <Box sx={{
            minHeight: "100vh",
            backgroundColor: '#fafafb',
            p: isMobile ? 1 : 0
        }} display={"flex"}
            alignItems={isMobile ? "flex-start" : "center"}
            justifyContent={"center"}
        >
            {objWait()}

            <Snackbar
                open={mensaje.length == 0 ? false : true}
                autoHideDuration={6000}
                onClose={handleCloseMensaje}
                action={actionMsg}
                message={mensaje}
                sx={isMobile ? { bottom: 70 } : {}}
            />
            <Paper
                elevation={6}
                sx={isMobile ? {
                    width: '100%',
                    maxWidth: '100%',
                    minHeight: 'auto',
                    margin: 0,
                    borderRadius: '12px',
                    background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                    boxShadow: '0 8px 32px rgba(30, 58, 95, 0.12)',
                    border: '1px solid rgba(30, 58, 95, 0.1)',
                    p: 0,
                    overflow: 'auto'
                } : {
                    border: "1px solid black", borderRadius: 1,
                    position: "absolute", top: "50%", left: "50%",
                    transform: "translate(-50%, -50%)", width: "700px", maxWidth: "90%", height: "800px",
                    p: 0, maxHeight: "80%", overflow: "scroll"
                }}
            >

                <Box sx={{
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                    borderRadius: '8px 8px 0 0',
                    borderBottom: '3px solid #d4af37'
                }} padding={isMobile ? 1.5 : 2}>
                    <Typography variant={isMobile ? 'h6' : 'h5'} sx={{ color: "white", textAlign: "center", fontWeight: 700, letterSpacing: 1 }}>Mi Cuenta</Typography>
                </Box>
                <BottomNavigation
                    sx={{
                        mb: isMobile ? 1 : 0,
                        '& .MuiBottomNavigationAction-root': {
                            minWidth: isMobile ? 'auto' : 80,
                            padding: isMobile ? '6px 12px' : '6px 12px 8px'
                        },
                        '& .MuiBottomNavigationAction-label': {
                            fontSize: isMobile ? '0.75rem' : '0.75rem'
                        }
                    }}
                    showLabels
                    onChange={(event, newValue) => {
                        if (newValue === 0) { handleClick() }
                    }}
                >
                    <BottomNavigationAction label="Grabar" icon={<AddCardIcon />} />
                </BottomNavigation>

                <Box padding={isMobile ? 1.5 : 2}>
                    {/* Input oculto para seleccionar archivo */}
                    <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFotoChange}
                        accept="image/*"
                        style={{ display: 'none' }}
                    />

                    {/* Sección de foto de perfil */}
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        mb: isMobile ? 2 : 3
                    }}>
                        <Badge
                            overlap="circular"
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            badgeContent={
                                <Box sx={{ display: 'flex', gap: 0.5 }}>
                                    <IconButton
                                        onClick={handleFotoClick}
                                        sx={{
                                            backgroundColor: '#1e3a5f',
                                            color: 'white',
                                            width: isMobile ? 32 : 36,
                                            height: isMobile ? 32 : 36,
                                            border: '2px solid white',
                                            '&:hover': {
                                                backgroundColor: '#2c5282'
                                            }
                                        }}
                                    >
                                        <CameraAltIcon sx={{ fontSize: isMobile ? 16 : 18 }} />
                                    </IconButton>
                                    {fotoPreview && (
                                        <IconButton
                                            onClick={handleEliminarFoto}
                                            sx={{
                                                backgroundColor: '#dc2626',
                                                color: 'white',
                                                width: isMobile ? 32 : 36,
                                                height: isMobile ? 32 : 36,
                                                border: '2px solid white',
                                                '&:hover': {
                                                    backgroundColor: '#b91c1c'
                                                }
                                            }}
                                        >
                                            <DeleteIcon sx={{ fontSize: isMobile ? 16 : 18 }} />
                                        </IconButton>
                                    )}
                                </Box>
                            }
                        >
                            <Avatar
                                src={fotoPreview}
                                sx={{
                                    width: isMobile ? 100 : 120,
                                    height: isMobile ? 100 : 120,
                                    border: '4px solid #d4af37',
                                    boxShadow: '0 4px 16px rgba(30, 58, 95, 0.25)',
                                    backgroundColor: '#e2e8f0',
                                    cursor: 'pointer',
                                    fontSize: isMobile ? '2.5rem' : '3rem',
                                    color: '#1e3a5f'
                                }}
                                onClick={handleFotoClick}
                            >
                                {!fotoPreview && nombre ? nombre.charAt(0).toUpperCase() : ''}
                            </Avatar>
                        </Badge>
                        <Typography
                            variant="caption"
                            sx={{
                                mt: 1.5,
                                color: '#64748b',
                                fontSize: isMobile ? '0.75rem' : '0.8rem'
                            }}
                        >
                            Toca para {fotoPreview ? 'cambiar' : 'agregar'} foto de perfil
                        </Typography>
                    </Box>

                    <Grid container spacing={isMobile ? 1.5 : 2}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                size={isMobile ? 'small' : 'medium'}
                                label="Nombre"
                                value={nombre}
                                onChange={(event) => { setNombre(event.target.value.toUpperCase()) }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                size={isMobile ? 'small' : 'medium'}
                                value={apellido}
                                onChange={(event) => { setApellido(event.target.value.toUpperCase()) }}
                                label="Apellido"
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size={isMobile ? 'small' : 'medium'}
                                value={celular}
                                type='tel'
                                onChange={(event) => { setCelular(event.target.value.toUpperCase()) }}
                                label="Celular"
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size={isMobile ? 'small' : 'medium'}
                                label="Email"
                                value={email}
                                type='email'
                                onChange={(event) => { setEmail(event.target.value.toUpperCase()) }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                size={isMobile ? 'small' : 'medium'}
                                value={direccion}
                                onChange={(event) => { setDireccion(event.target.value.toUpperCase()) }}
                                label="Dirección"
                                variant="outlined"
                            />
                        </Grid>

                    </Grid>
                    <Paper elevation={2} sx={{ marginTop: isMobile ? "20px" : "40px" }}>
                        <Box textAlign={"center"} sx={{
                            background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                            borderRadius: '6px 6px 0 0',
                            borderBottom: '2px solid #d4af37',
                            py: isMobile ? 0.75 : 1
                        }}>
                            <Typography variant={isMobile ? 'subtitle1' : 'h6'} sx={{ color: '#d4af37', fontWeight: 600, letterSpacing: 1 }}>Datos Usuario</Typography>
                        </Box>
                        <Grid container spacing={isMobile ? 1.5 : 2} padding={isMobile ? 1.5 : 2}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    size={isMobile ? 'small' : 'medium'}
                                    label="Usuario"
                                    value={usuario}
                                    disabled
                                    variant="outlined"
                                />
                            </Grid>

                            {/* Botón para cambiar contraseña */}
                            <Grid item xs={12}>
                                <Button
                                    variant={mostrarCambioPassword ? "outlined" : "contained"}
                                    startIcon={<LockResetIcon />}
                                    endIcon={mostrarCambioPassword ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    onClick={() => {
                                        if (mostrarCambioPassword) {
                                            handleCancelarCambioPassword();
                                        } else {
                                            setMostrarCambioPassword(true);
                                            setClave("");
                                            setRepite("");
                                        }
                                    }}
                                    fullWidth
                                    size={isMobile ? 'medium' : 'large'}
                                    sx={{
                                        mt: 1,
                                        py: isMobile ? 1.25 : 1.5,
                                        fontSize: isMobile ? '0.85rem' : '1rem',
                                        background: mostrarCambioPassword
                                            ? 'transparent'
                                            : 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                                        color: mostrarCambioPassword ? '#1e3a5f' : 'white',
                                        borderColor: '#1e3a5f',
                                        '&:hover': {
                                            background: mostrarCambioPassword
                                                ? 'rgba(30, 58, 95, 0.1)'
                                                : 'linear-gradient(135deg, #2c5282 0%, #3d6a9f 100%)',
                                            borderColor: '#2c5282',
                                        }
                                    }}
                                >
                                    {mostrarCambioPassword ? 'Cancelar' : 'Cambiar Contraseña'}
                                </Button>
                            </Grid>

                            {/* Campos de contraseña - solo visibles si se está cambiando */}
                            {mostrarCambioPassword && (
                                <>
                                    <Grid item xs={12}>
                                        <Box sx={{
                                            p: isMobile ? 1.5 : 2,
                                            mt: 1,
                                            backgroundColor: '#fff3cd',
                                            borderRadius: 1,
                                            border: '1px solid #ffc107'
                                        }}>
                                            <Typography variant="body2" sx={{ color: '#856404', fontSize: isMobile ? '0.8rem' : '0.875rem' }}>
                                                Ingrese su nueva contraseña y confírmela
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            size={isMobile ? 'small' : 'medium'}
                                            label="Nueva Clave"
                                            type={showClave ? 'text' : 'password'}
                                            value={clave}
                                            onChange={(event) => { setClave(event.target.value) }}
                                            variant="outlined"
                                            placeholder="Nueva clave"
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={() => setShowClave(!showClave)}
                                                            onMouseDown={(e) => e.preventDefault()}
                                                            edge="end"
                                                            size="small"
                                                        >
                                                            {showClave ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            size={isMobile ? 'small' : 'medium'}
                                            type={showRepite ? 'text' : 'password'}
                                            value={repite}
                                            onChange={(event) => { setRepite(event.target.value) }}
                                            label="Repita"
                                            variant="outlined"
                                            placeholder="Confirme"
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={() => setShowRepite(!showRepite)}
                                                            onMouseDown={(e) => e.preventDefault()}
                                                            edge="end"
                                                            size="small"
                                                        >
                                                            {showRepite ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                </>
                            )}

                        </Grid>
                    </Paper>

                    {/* Sección de Inversiones Automáticas */}
                    <Paper elevation={2} sx={{ marginTop: isMobile ? "20px" : "30px" }}>
                        <Box textAlign={"center"} sx={{
                            background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                            borderRadius: '6px 6px 0 0',
                            borderBottom: '2px solid #d4af37',
                            py: isMobile ? 0.75 : 1
                        }}>
                            <Typography variant={isMobile ? 'subtitle1' : 'h6'} sx={{ color: '#d4af37', fontWeight: 600, letterSpacing: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                                <AutoModeIcon /> Inversiones Automáticas
                            </Typography>
                        </Box>
                        <Grid container spacing={isMobile ? 1.5 : 2} padding={isMobile ? 1.5 : 2}>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={inversionAutomatica === 1}
                                            onChange={(e) => {
                                                setInversionAutomatica(e.target.checked ? 1 : 0)
                                                if (!e.target.checked) {
                                                    setInversionTipo("")
                                                    setInversionMonto("")
                                                    setInversionPorciento("")
                                                }
                                            }}
                                            color="primary"
                                        />
                                    }
                                    label={
                                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                            Activar inversiones automáticas
                                        </Typography>
                                    }
                                />
                                <Typography variant="caption" sx={{ display: 'block', color: '#64748b', mt: 0.5, ml: 6 }}>
                                    Permite que el sistema invierta automáticamente cuando haya préstamos disponibles
                                </Typography>
                            </Grid>

                            {inversionAutomatica === 1 && (
                                <>
                                    <Grid item xs={12}>
                                        <Box sx={{
                                            p: isMobile ? 1.5 : 2,
                                            backgroundColor: '#e3f2fd',
                                            borderRadius: 1,
                                            border: '1px solid #2196f3'
                                        }}>
                                            <Typography variant="body2" sx={{ color: '#1565c0', fontWeight: 500, mb: 1 }}>
                                                Seleccione el tipo de inversión automática:
                                            </Typography>
                                            <RadioGroup
                                                value={inversionTipo}
                                                onChange={(e) => {
                                                    setInversionTipo(e.target.value)
                                                    // Limpiar el campo contrario
                                                    if (e.target.value === "MONTO") {
                                                        setInversionPorciento("")
                                                    } else if (e.target.value === "PORCIENTO") {
                                                        setInversionMonto("")
                                                    }
                                                }}
                                            >
                                                <FormControlLabel
                                                    value="MONTO"
                                                    control={<Radio />}
                                                    label="Por monto fijo"
                                                />
                                                <FormControlLabel
                                                    value="PORCIENTO"
                                                    control={<Radio />}
                                                    label="Por porcentaje del préstamo"
                                                />
                                            </RadioGroup>
                                        </Box>
                                    </Grid>

                                    {inversionTipo === "MONTO" && (
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                size={isMobile ? 'small' : 'medium'}
                                                label="Monto a invertir"
                                                type="number"
                                                value={inversionMonto}
                                                onChange={(e) => setInversionMonto(e.target.value)}
                                                variant="outlined"
                                                placeholder="Ej: 5000"
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start">RD$</InputAdornment>
                                                }}
                                                helperText="Monto fijo que se invertirá automáticamente en cada préstamo disponible"
                                            />
                                        </Grid>
                                    )}

                                    {inversionTipo === "PORCIENTO" && (
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                size={isMobile ? 'small' : 'medium'}
                                                label="Porcentaje a invertir"
                                                type="number"
                                                value={inversionPorciento}
                                                onChange={(e) => setInversionPorciento(e.target.value)}
                                                variant="outlined"
                                                placeholder="Ej: 10"
                                                InputProps={{
                                                    endAdornment: <InputAdornment position="end">%</InputAdornment>
                                                }}
                                                inputProps={{ min: 1, max: 100 }}
                                                helperText="Porcentaje del monto disponible del préstamo que se invertirá automáticamente"
                                            />
                                        </Grid>
                                    )}
                                </>
                            )}
                        </Grid>
                    </Paper>
                </Box>


            </Paper>
        </Box>

    )
}